import React from "react";
import $ from "jquery";
import { AxiosResponse } from "axios";

import Loading from "../../../intelws_portal/constructs/elements/Loading";
import { get, getCancelToken, post } from "../../../intelws_portal/utils/backendInterface";

import { IPageComponentProps } from "../../../declarations/common";
import { getBundledAlertsUI } from "../../../declarations/common_utils";
import { EventClickArg, EventContentArg, EventSourceInput } from "@fullcalendar/common";

import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import ModalLeadFollowUpInfo from "../modal/ModalLeadFollowUpInfo";
import ContentBoxAdv from "../../../intelws_portal/constructs/elements/ContentBoxAdv";
import { IFollowUpEvents } from "./LeadTracking";
import ModalDropDown from "../../../intelws_portal/constructs/modal/ModalDropDown";
import ModalUserFollowup from "../modal/ModalUserFollowup";

interface IEmployeeInfo {
    id: number,
    emp_full_name: string
}

interface IFetchLeadFollowUpEvents extends AxiosResponse {
    data: {
        data: IFollowUpEvents[]
        emp_data: IEmployeeInfo[]
        selected_emp: number
    }
}

function ClientFollowup(props: IPageComponentProps) {
    const ENDPOINT = "/api/userlist/";
    const [isLoaded, setIsLoaded] = React.useState(false);
    const [currTab, setCurrTab] = React.useState(0);
    const [success, setSuccess] = React.useState<string[]>([]);
    const [fail, setFail] = React.useState<string[]>([]);

    const [leadFollowUpId, setLeadFollowUpId] = React.useState(-1);

    const [employeeInfo, setEmployeeInfo] = React.useState<IEmployeeInfo[]>([]);

    const [selectedEmpId, setSelectedEmpId] = React.useState(-1);

    const [employeeGroupedFollowUpEvents, setEmployeeGroupedFollowUpEvents] = React.useState<Record<number, IFollowUpEvents[]>>({});

    const calendarRef = React.useRef(null);

    const cancelTokenSource = React.useRef(getCancelToken());

    React.useEffect(() => {
        if (props.mutator != undefined && props.mutator.currentPage != undefined) {
            props.mutator.currentPage("LeadTracking");
        }

        const queryParams = {
            section: "get_client_followup"
        }

        const followUpEventsResponse = get(ENDPOINT, cancelTokenSource.current.token, queryParams) as Promise<IFetchLeadFollowUpEvents>;
        followUpEventsResponse.then((response) => {
            setEmployeeGroupedFollowUpEvents(() => {
                let newValue: Record<number, IFollowUpEvents[]> = {};
                response.data.data.forEach((currEvent) => {
                    if (!(currEvent.uf_emp_id in newValue)) {
                        newValue[currEvent.uf_emp_id] = [];
                    }
                    newValue[currEvent.uf_emp_id].push(currEvent);
                })

                return newValue;
            })
            setEmployeeInfo(response.data.emp_data);
            setSelectedEmpId(response.data.selected_emp);
            setIsLoaded(true);
        })


    }, [])

    React.useEffect(() => {
        if (currTab === 1) {
            if (calendarRef.current) {
                setTimeout(() => {
                    (calendarRef.current as any).getApi().updateSize();
                }, 0);
            }
        }
    }, [currTab])

    function modalMarkFollowUp(leadFollowUpId: number, success?: string[], fail?: string[]) {
        setEmployeeGroupedFollowUpEvents((prevEmployeeGrouptedFollowUpEvents) => {
            let newValue = { ... prevEmployeeGrouptedFollowUpEvents }
            Object.entries(prevEmployeeGrouptedFollowUpEvents).forEach(([empId, empEvents]) => {
                let numEmpId = parseInt(empId);
                newValue[numEmpId] = newValue[numEmpId].filter(currEvent => currEvent.id !== leadFollowUpId)
            })
            return newValue;
        })

        if (success != undefined && fail != undefined) {
            setSuccess(success);
            setFail(fail);
        }
    }

    function modalEditFollowUp(newEvent?: IFollowUpEvents, success?: string[], fail?: string[]) {
        if (newEvent != undefined) {
            setEmployeeGroupedFollowUpEvents((prevEmployeeGroupedFollowUpEvents) => {
                let newValue = {...prevEmployeeGroupedFollowUpEvents};
                Object.entries(prevEmployeeGroupedFollowUpEvents).forEach(([empId, empEvents]) => {
                    let numEmpId = parseInt(empId);
                    let editIndex = newValue[numEmpId].findIndex(currEvent => currEvent.id === newEvent.id);
                    if (editIndex != -1) {
                        newValue[numEmpId][editIndex] = newEvent;
                    }
                })
                return newValue;
            })
        }

        if (success != undefined && fail != undefined) {
            setSuccess(success);
            setFail(fail);
        }
    }

    function leadFollowUpEventOnClick(eventInfo: EventClickArg) {
        setLeadFollowUpId(eventInfo.event.extendedProps.id as number);
        $("#leadFollowUpInfoModal").modal("show");
    }

    function getLeadFollowUpContent() {
        const renderEventContent = (eventInfo: EventContentArg) => {
            return <>
                <p>{eventInfo.event.title}</p>
            </>
        }

        const getSeededColor = (seed: string | number): string => {
            // Use a numeric hash of the string for consistency
            const str = String(seed);
            const numericSeed = str.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);

            // Scramble the hue using the Golden Ratio
            const goldenRatioConjugate = 0.618033988749895;
            const hue = (goldenRatioConjugate * numericSeed) % 1; // 0-1 range

            // Set consistent saturation and lightness for vivid colors
            const saturation = 0.85;
            const lightness = 0.65;

            // HSL to RGB conversion helper
            const hslToRgb = (h: number, s: number, l: number): string => {
                let r: number, g: number, b: number;
                if (s === 0) {
                    r = g = b = l; // achromatic
                } else {
                    const hue2rgb = (p: number, q: number, t: number): number => {
                        if (t < 0) t += 1;
                        if (t > 1) t -= 1;
                        if (t < 1 / 6) return p + (q - p) * 6 * t;
                        if (t < 1 / 2) return q;
                        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
                        return p;
                    };
                    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
                    const p = 2 * l - q;
                    r = hue2rgb(p, q, h + 1 / 3);
                    g = hue2rgb(p, q, h);
                    b = hue2rgb(p, q, h - 1 / 3);
                }
                const toHex = (c: number): string => Math.round(c * 255).toString(16).padStart(2, '0');
                return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
            };

            return hslToRgb(hue, saturation, lightness);
        };

        const eventSources: EventSourceInput[] = []

        Object.entries(employeeGroupedFollowUpEvents).forEach(([empId, empEvents]) => {
            if (selectedEmpId != -1 && parseInt(empId) != selectedEmpId) {
                return
            }

            eventSources.push({
                events: empEvents.map(eventData => { return { title: eventData.title, date: eventData.date_str, extendedProps: { id: eventData.id } } }),
                color: getSeededColor(empId),
                textColor: 'white'
            });
        })

        return (
            <FullCalendar ref={calendarRef} plugins={[dayGridPlugin, timeGridPlugin]} initialView="dayGridMonth"
                headerToolbar={{ left: 'prev,next today', right: 'dayGridMonth,timeGridWeek,timeGridDay' }}
                eventContent={renderEventContent} eventClick={leadFollowUpEventOnClick} eventSources={eventSources} />
        )
    }

    function getContent() {
        const employeeOptions = ["Select Employee", ...employeeInfo.map(ele => ele.emp_full_name)]
        const employeeValues = [-1, ...employeeInfo.map(ele => ele.id)];
        const title = 
            <>
                {"Client Follow Up"}
                {employeeInfo.length > 1
                    ? <ModalDropDown options={employeeOptions} values={employeeValues} value={selectedEmpId} onChange={(e) => setSelectedEmpId(parseInt(e.target.value))} />
                    : null
                }
            </>
        return (
            <ContentBoxAdv title={title} body={getLeadFollowUpContent()} />
        )
    }

    function modalAddFollowUpSaveCallback(data?: IFollowUpEvents, success?: string[], fail?: string[]) {
        if (data != undefined) {
            setEmployeeGroupedFollowUpEvents((prevEmployeeGroupedFollowUpEvents) => {
                let newValue = {...prevEmployeeGroupedFollowUpEvents}
                if (!(data.uf_emp_id in newValue)) {
                    newValue[data.uf_emp_id] = []
                }
                newValue[data.uf_emp_id] = [...newValue[data.uf_emp_id], data]
                return newValue;
            })
        }
        if (success != undefined && fail != undefined) {
            setSuccess(success);
            setFail(fail);
        }
    }

    function getAddModal(){
        /*
        return (
            <ModalLeadAdd saveCallback={modalAddSaveCallbackForEdit} leadId={leadId} firstName={firstName}
                lastname={lastName} email={email} contact={phoneNum} contactPref={contactWay} contactRef={refMethod} clearModal={clearModal} />
        )
        */

    }
    if (!isLoaded) {
        return <Loading />
    } else {
        return (
            <div className="body-content-wrapper clearfix">
                {getBundledAlertsUI(success, fail, setSuccess, setFail)}
                {getContent()}
                {getAddModal()}
                <ModalLeadFollowUpInfo leadFollowUpId={leadFollowUpId} closeModal={() => setLeadFollowUpId(-1)} markAsCompleted={modalMarkFollowUp} editFollowUp={modalEditFollowUp} isClient />
            </div>

        )
    }
}

export default ClientFollowup;